import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";



import { editDescription } from "./fetch";

const BACKGROUND_COLOR = "backgroundColor";
const UPLOAD_PHOTO = "uploadPhoto";
const MEDIA = "media";
const DESCRIPTION = "description";

export const signupOptionKeys = createKeys(
  featureKeys.SIGNUP_PUBLIC_DESIGN_OPTIONS,
  {
    backgroundColor: ({ signupID, color }) => [
      BACKGROUND_COLOR,
      signupID,
      color,
    ],
    uploadPhoto: () => [UPLOAD_PHOTO],
    editMediaSettings: ({ signupID }) => [MEDIA, signupID],
    editDescription: ({ signupID }) => [DESCRIPTION, signupID],
  }
);